module.exports = __webpack_public_path__ + "components/MapControl/svg/Postój taksówek.svg?1bf9752f";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Postój taksówek.svg
// module id = 2021
// module chunks = 0